import axios from '../axios'

/* 
 * 分类模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/customer/save',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/customer/findPage',
        method: 'post',
        data
    })
}
export const getStatus = (data) => {
    return axios({
        url: '/customer/getStatus',
        method: 'post',
        data
    })
}
export const getIntegral = (data) => {
    return axios({
        url: '/customer/getIntegral',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/customer/delete',
        method: 'post',
        data
    })
}

// 查询
export const findPageAll = (data) => {
    return axios({
        url: '/customer/findPageAll',
        method: 'post',
        data
    })
}

export const integralLog = (data) => {
    return axios({
        url: '/customer/integralLog',
        method: 'post',
        data
    })
}

export const getIntegralAll = (data) => {
    return axios({
        url: '/customer/getIntegralAll',
        method: 'post',
        data
    })
}

export const getIntegralDetail = (data) => {
    return axios({
        url: '/customer/getIntegralDetail',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/client.js